"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BroadbandCartCms = void 0;
var BroadbandCartCms = /** @class */ (function () {
    function BroadbandCartCms() {
        this.lineOfBusinessName = 'Internet';
        this.titlePackage = 'PLAN';
        this.learnMoreLabel = 'Learn more';
        this.dueTodayLegalIDP = {
            legalModalPath: [
                '/idpassets/fragment/legal/2007b/legalmodal/offers/wireline/cart/duetodaychargesdtvlm.cmsfeed.js',
            ],
            legalShortPath: {
                legalText: 'Due today',
                shortLegalLinkLabel: 'See details',
            },
        };
        this.dueOnFirstBillLegalIDP = {
            legalModalPath: [
                '/idpassets/fragment/legal/2007b/legalmodal/offers/wireline/cart/seasonalsubscriptionslm.cmsfeed.js',
            ],
            legalShortPath: {
                legalText: '<p>These services auto-renew, unless otherwise noted, every season unless you call to cancel.</p>\n<p>&nbsp;</p>\n',
                shortLegalLinkLabel: 'See details',
            },
        };
        this.bbPricingDueOnFirstBillLegalIDP = {
            legalModalPath: [
                '/idpassets/fragment/legal/2103d/legalmodal/offers/wireline/broadband/bbpricingdueonfirstbilllm.cmsfeed.js',
            ],
            legalShortPath: {
                legalText: 'Due on 1st bill',
                shortLegalLinkLabel: 'See details',
            },
        };
        this.learnMoreLegal = '/ecms/sharedcontent/en/legal/ipd-platform/sales/buy/internetonly/internetdataallowance/'
            + '_jcr_content/desktoplegal/legalsharedcontent.json';
        this.dueMonthlyHeading = 'Monthly charges';
        this.dueOneTimeCharges = 'One-time charges TEST';
        this.dueOneTimeChargesPlusTaxLabel = 'One-time charges (plus taxes)';
        this.subTotalLabel = 'Subtotal';
        this.removeInternetLabel = 'Remove Internet';
        this.additionalDataLabel = 'ADDITIONAL DATA';
        this.planSpeedAndLimit = 'Up to [[X]]Mbps download with [[X]]';
        this.installationFee = '[[0]]/mo. for [[0]] months';
        this.titleEquipment = 'EQUIPMENT';
        this.addonTitle = 'Add-ons';
        this.oneTimeChargeTitle = 'One-time charge:';
        this.removeItemsLinkLabel = 'Remove Internet';
        this.installementLabel = 'Installment billing eligible';
        this.installmentBillingSelected = 'Installment billing selected';
        this.specialHsiaOffers = '18';
        this.includedLabel = 'Included';
        this.installmentEligibleTip = 'At checkout, we\'ll ask you if  want to pay this one-time fee' +
            ' on your first bill or in several monthly payments.';
        this.infoLowestPriceHeading = 'With AT&T, you\'re getting the lowest price for 1000Mbps internet!*';
        this.acpVerficationMessage = 'You\'ll have to reapply your ACP benefit to your order.' +
            'Please go back and complete the steps to let us know you were approved. When you\'re done, come back to finish your order.';
        this.acpVerifcationLink = 'Go back & apply benefit';
        this.acpVerificationURL = '/help/acp/customer/?serviceType=BroadBand';
        this.acpSystemErrorMessageFirst = 'We hit a snag and weren\'t able to apply your ACP benefit. Please call us at';
        this.acpSystemErrorMessageSecond = ',so we can help with your order.';
        this.acpSystemErrorNumber = '866.986.0963';
        this.infoLowestPriceLegal = '*Comparison of first year pricing for AT&T Internet to major cable providers' +
            ' Xfinity, Spectrum, & Cox 1 Gig Cable Service.';
        this.offerSku = 'sku10540250';
        this.dmaList = '524,520,635,800,716,692,630,648,519,564,517,575,602,515,';
        this.emptyCartModal = {
            cancelButtonLabel: 'No',
            removeButtonLabel: 'Yes',
            removeModalBody: 'Sure you want to remove this?',
            removeModalTitle: 'Remove from cart',
        };
    }
    return BroadbandCartCms;
}());
exports.BroadbandCartCms = BroadbandCartCms;
//# sourceMappingURL=BroadbandCart.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/BroadbandCart/BroadbandCart.cms.js
// module id = 256
// module chunks = 8